import { RewardType } from '~/shared';

interface DonateItemRowOptions {
	type: RewardType;
	value: string;
	count: string;
	tuningKit: string;
	tuningItems: string[];
	sellAmount: string;
	sellIsDonate: boolean;
}

const createDonateItemRow = ({
	type,
	value,
	count,
	tuningKit,
	tuningItems,
	sellAmount,
	sellIsDonate,
}: DonateItemRowOptions): string | null => {
	const rewardId = value.trim();
	if (!rewardId) {
		return null;
	}

	const itemCount = Number(count) || 1;
	let rewardValue = rewardId;

	if (type === RewardType.ITEM) {
		rewardValue = JSON.stringify({
			id: rewardId,
			...(itemCount > 1 && { count: itemCount }),
		});
	}

	if (type === RewardType.VEHICLE) {
		const tuning = {
			...(tuningKit && { kit: tuningKit }),
			...(tuningItems.length > 0 && { items: tuningItems }),
		};
		rewardValue = JSON.stringify({
			model: rewardId,
			...(Object.keys(tuning).length > 0 && { tuning }),
		});
	}

	const isSellable = sellAmount.trim() !== '';
	return [
		`${type}_${rewardId}`,
		type,
		rewardValue,
		isSellable ? sellAmount : '',
		sellIsDonate ? 'TRUE' : 'FALSE',
	].join('\t');
};

export { createDonateItemRow };
